var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFloatingClose = function SvgIconFloatingClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.253 2.986a.827.827 0 0 0-1.17 1.17L6.927 8l-3.844 3.844a.827.827 0 1 0 1.17 1.17L8.097 9.17l3.782 3.781a.827.827 0 1 0 1.17-1.17L9.267 8l3.781-3.782a.827.827 0 0 0-1.17-1.17L8.098 6.83 4.252 2.986Z",
    fill: "#242526"
  })));
};
export default SvgIconFloatingClose;